/** HTTP base for admin backend (port 81 locally; same origin on HTTPS deploy). */
export function getHttpApiBase(): string {
	const apiUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');
	if (!apiUrl) {
		return '';
	}

	const port = (process.env.REACT_APP_PORT ?? '').trim();
	if (apiUrl.startsWith('https://')) {
		return apiUrl;
	}

	if (port && !/:\d+$/.test(apiUrl)) {
		return `${apiUrl}:${port}`;
	}

	return apiUrl;
}

export function apiUrl(path: string): string {
	const base = getHttpApiBase();
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	return base ? `${base}${normalizedPath}` : normalizedPath;
}
